import '../../forms/forms-core/components/form-field/FormField.css';
import '../../forms/forms-core/components/form-field-messages/FormFieldMessageItem.css';
import '../../forms/forms-core/components/form-field-messages/FormFieldMessages.css';
import './InputGroup.css';
export var inputGroup = '_6l3c2c0-2-0-1';
export var inputGroupClassName = 'strato-inputgroup';